// Mock data for Outaouais Big Game Hunting

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À Propos',
      services: 'Services',
      packages: 'Forfaits',
      fishing: 'Pêche',
      gallery: 'Galerie',
      testimonials: 'Témoignages',
      contact: 'Contact'
    },
    hero: {
      title: 'Outaouais Big Game Hunting',
      subtitle: 'Votre Destination Ultime pour la Chasse au Gros Gibier',
      description: 'Découvrez l\'expérience authentique de la chasse en pourvoirie dans les magnifiques forêts de l\'Outaouais',
      cta: 'Réserver Maintenant',
      ctaSecondary: 'En Savoir Plus'
    },
    about: {
      title: 'À Propos de Notre Pourvoirie',
      subtitle: 'Une Tradition de Chasse Depuis Plusieurs Générations',
      description: 'Située au cœur de l\'Outaouais, notre pourvoirie offre une expérience de chasse exceptionnelle. Accès à plus de 20 sites de chasse actifs depuis plus de 10 ans, avec renouvellement de territoire à chaque 5 ans pour régénérer la faune locale. Plus de 25 ans d\'expérience en forêt et 12 ans d\'expérience comme guide professionnel.',
      stats: [
        { number: '25+', label: 'Années d\'Expérience en Forêt' },
        { number: '12+', label: 'Années comme Guide' },
        { number: '20+', label: 'Sites de Chasse Actifs' },
        { number: '30000+', label: 'Acres de Territoire Libre' }
      ]
    },
    services: {
      title: 'Nos Services de Chasse',
      subtitle: 'Des Expériences de Chasse Exceptionnelles',
      items: [
        {
          name: 'Chasse au Cerf',
          description: 'Traquez le cerf de Virginie dans nos vastes territoires. Excellente population et trophées impressionnants.',
          features: ['Guides expérimentés', 'Territoires exclusifs', 'Équipement fourni', 'Support complet']
        },
        {
          name: 'Chasse à l\'Ours',
          description: 'Vivez l\'excitation de la chasse à l\'ours noir avec nos guides experts. Tous les séjours de chasse à l\'ours sont jumelés avec le droit de pêche!',
          features: ['Affûts préparés', 'Appâtage professionnel', 'Droit de pêche inclus', '20+ sites actifs depuis 10+ ans']
        },
        {
          name: 'Chasse au Dindon',
          description: 'Le dindon sauvage au printemps, une expérience unique dans les forêts de l\'Outaouais.',
          features: ['Saison printanière', 'Techniques d\'appel', 'Guides spécialisés', 'Petits groupes']
        }
      ]
    },
    packages: {
      title: 'Nos Forfaits Chasse à l\'Ours',
      subtitle: 'Tous les Forfaits Incluent le Droit de Pêche',
      note: 'Les prix affichés sont sans guide. Possibilité d\'avoir un guide professionnel qui vous accompagne pour maximiser le succès.',
      guidePrice: '* Prix d\'un guide professionnel : 299,99 $ / jour',
      chaletMin: '* Minimum de 2 personnes pour commodité chalet',
      fishingGuide: 'Possibilité de pêche guidée disponible sur demande.',
      items: [
        {
          name: 'Séjour Camping',
          duration: '4 Jours / 3 Nuits',
          price: '1099',
          features: [
            'Emplacement de camping',
            '4 jours de chasse à l\'ours',
            'Droit de pêche inclus',
            'Accès 20+ sites de chasse actifs',
            'Appâtage professionnel',
            'Transport sur territoire'
          ],
          popular: false
        },
        {
          name: 'Séjour Hébergement Chalet',
          duration: '4 Jours / 3 Nuits',
          price: '1599.99',
          features: [
            'Hébergement confortable en chalet',
            '4 jours de chasse à l\'ours',
            'Droit de pêche inclus',
            'Accès Lac Saint-Marie et lacs reculés',
            'Appâtage professionnel',
            'Préparation du gibier'
          ],
          popular: true
        },
        {
          name: 'Séjour VIP - Saison Complète',
          duration: 'Saison Complète d\'Ours',
          price: '2500',
          spotsLeft: 'Seulement 6 places disponibles!',
          features: [
            'Hébergement roulotte/fifth wheel avec hydro',
            'Accès saison complète chasse à l\'ours',
            'Droit de pêche illimité toute saison',
            'Accès Lac Saint-Marie (doré, brochet, truite)',
            'Accès lacs secrets (truite mouchetée)',
            'Sites renouvelés aux 5 ans',
            'Appâtage professionnel'
          ],
          popular: false
        }
      ]
    },
    deerRules: {
      title: 'Règlements Chasse au Cerf',
      subtitle: 'Informations Importantes',
      rules: [
        {
          title: 'RTLB OBLIGATOIRE',
          description: 'Une surcharge de 1000$ doit être payée si vous récoltez un buck qui ne respecte pas le RTLB (Règlement sur la Taille Légale des Bois).'
        },
        {
          title: 'Protection de la Faune',
          description: 'Aucune récolte de femelle avec veaux. Vous venez chasser avec nous pour avoir la chance de récolter un buck mature et non pour remplir votre congélateur.'
        },
        {
          title: 'Exception Relève',
          description: 'Exception pour les enfants relève entre 12 et 17 ans. Nous donnons ce privilège à seulement 1 enfant de la relève par territoire chassé par année.'
        }
      ]
    },
    groupSpecials: {
      title: 'Spéciaux de Groupe',
      subtitle: 'Économisez en Chassant en Groupe',
      specials: [
        {
          title: 'Groupe de 4 Chasseurs ou Plus',
          description: 'Le 5ème chasseur est à moitié prix!'
        },
        {
          title: 'Relève Gratuite (12-14 ans)',
          description: 'Enfants de 12 à 14 ans relève obtiennent leur séjour gratuitement. Seulement 1 enfant par groupe peut obtenir sa chasse gratuitement.'
        }
      ]
    },
    gallery: {
      title: 'Galerie Photos',
      subtitle: 'Découvrez Nos Trophées et Installations',
      categories: ['Tous', 'Cerfs', 'Ours', 'Dindons', 'Installations', 'Territoire']
    },
    turkeyPackage: {
      title: 'Forfait Dindon Guidé',
      package: {
        name: 'Séjour Dindon Guidé',
        duration: '3 Jours / 2 Nuits',
        price: '1199',
        features: [
          'Hébergement en chalet confortable',
          '3 jours de chasse guidée au dindon',
          'Guide professionnel expérimenté',
          'Techniques d\'appel spécialisées',
          'Territoires exclusifs',
          'Équipement de base fourni'
        ]
      }
    },
    deerPackages: {
      title: 'Nos Forfaits Chasse au Cerf',
      subtitle: 'Chassez le Buck Mature',
      deposit: '30% de dépôt à la réservation de votre séjour',
      note: 'Les prix affichés sont sans guide. Possibilité d\'avoir un guide professionnel.',
      guidePrice: '* Prix d\'un guide professionnel : 299,99 $ / jour',
      chaletMin: '* Minimum de 2 personnes pour commodité chalet',
      items: [
        {
          name: 'Séjour Camping',
          duration: '4 Jours / 3 Nuits',
          price: '1099',
          features: [
            'Emplacement de camping',
            '4 jours de chasse au cerf',
            'Territoires privés exclusifs',
            'RTLB obligatoire',
            'Transport sur territoire',
            'Appât/Cache fournis'
          ],
          popular: false
        },
        {
          name: 'Séjour Hébergement Chalet',
          duration: '4 Jours / 3 Nuits',
          price: '1599.99',
          features: [
            'Hébergement confortable en chalet',
            '4 jours de chasse au cerf',
            'Territoires privés exclusifs',
            'Guide expérimenté (12+ ans)',
            'RTLB obligatoire',
            'Préparation du gibier'
          ],
          popular: true
        },
        {
          name: 'Séjour VIP - Saison Complète',
          duration: 'Saison Complète de Cerf',
          price: '2500',
          features: [
            'Hébergement roulotte/fifth wheel avec hydro',
            'Accès saison complète chasse au cerf',
            'Territoires privés renouvelés aux 5 ans',
            'Sites multiples disponibles',
            'RTLB obligatoire',
            'Guide privé disponible',
            'Préparation et conservation'
          ],
          popular: false
        }
      ]
    },
    gallery: {
      title: 'Pêche Incluse',
      subtitle: 'Accès à Des Plans d\'Eau Exceptionnels',
      description: 'Tous les séjours de chasse à l\'ours incluent le droit de pêche. Apportez vos propres embarcations.',
      locations: [
        {
          name: 'Lac Saint-Marie',
          description: 'Immense et majestueux lac pour taquiner le doré, brochet et truite grise',
          species: ['Doré', 'Brochet', 'Truite Grise']
        },
        {
          name: 'Lacs Reculés Secrets',
          description: 'Plusieurs petits lacs reculés et secrets pour pêcher la truite mouchetée',
          species: ['Truite Mouchetée']
        }
      ],
      note: 'Vous devez apporter vos propres embarcations pour votre pêche.'
    },
    testimonials: {
      title: 'Témoignages',
      subtitle: 'Ce Que Disent Nos Clients',
      items: [
        {
          name: 'Jean-Marc Dubois',
          location: 'Montréal, QC',
          rating: 5,
          text: 'Une expérience exceptionnelle! Les guides sont professionnels et le territoire est magnifique. J\'ai réussi à abattre un cerf de 8 pointes. Je reviendrai sans hésiter!',
          hunt: 'Chasse au cerf - Octobre 2024'
        },
        {
          name: 'Robert Thompson',
          location: 'Toronto, ON',
          rating: 5,
          text: 'Best hunting experience I\'ve had in Canada. The staff is incredible, accommodations are comfortable, and the success rate speaks for itself. Highly recommended!',
          hunt: 'Bear Hunt - September 2024'
        },
        {
          name: 'Pierre Lavoie',
          location: 'Gatineau, QC',
          rating: 5,
          text: 'Parfait du début à la fin. L\'accueil chaleureux, les installations impeccables et les guides passionnés font toute la différence. Mon fils et moi avons vécu des moments inoubliables.',
          hunt: 'Chasse au dindon - Mai 2024'
        }
      ]
    },
    contact: {
      title: 'Contactez-Nous',
      subtitle: 'Réservez Votre Prochaine Aventure',
      form: {
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Adresse Email',
        phone: 'Téléphone',
        huntType: 'Type de Chasse',
        huntTypes: {
          deer: 'Cerf',
          bear: 'Ours',
          turkey: 'Dindon',
          multiple: 'Combinaison'
        },
        dates: 'Dates Souhaitées',
        guests: 'Nombre de Chasseurs',
        message: 'Message / Questions',
        submit: 'Envoyer la Demande',
        success: 'Merci! Nous vous contactons sous 24h.',
        error: 'Erreur lors de l\'envoi. Veuillez réessayer.'
      },
      info: {
        title: 'Informations',
        address: '7 Chemin du Marais, Danford Lake, QC',
        phone: '(819) 431-2712',
        email: 'hdnighttrain@outlook.com',
        hours: 'Lundi - Dimanche: 8h - 20h'
      }
    },
    footer: {
      description: 'Votre destination ultime pour la chasse au gros gibier dans l\'Outaouais. Expérience, tradition et succès garantis.',
      quickLinks: 'Liens Rapides',
      followUs: 'Suivez-Nous',
      rights: 'Tous droits réservés.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      home: 'Home',
      about: 'About',
      services: 'Services',
      packages: 'Packages',
      fishing: 'Fishing',
      gallery: 'Gallery',
      testimonials: 'Testimonials',
      contact: 'Contact'
    },
    hero: {
      title: 'Outaouais Big Game Hunting',
      subtitle: 'Your Ultimate Big Game Hunting Destination',
      description: 'Experience authentic outfitter hunting in the beautiful forests of Outaouais',
      cta: 'Book Now',
      ctaSecondary: 'Learn More'
    },
    about: {
      title: 'About Our Outfitter',
      subtitle: 'A Hunting Tradition for Generations',
      description: 'Located in the heart of Outaouais, our outfitter offers an exceptional hunting experience. Access to over 20 active hunting sites for more than 10 years, with territory renewal every 5 years to regenerate local wildlife. Over 25 years of forest experience and 12 years as a professional guide.',
      stats: [
        { number: '25+', label: 'Years Forest Experience' },
        { number: '12+', label: 'Years as Guide' },
        { number: '20+', label: 'Active Hunting Sites' },
        { number: '30000+', label: 'Acres Free Territory' }
      ]
    },
    services: {
      title: 'Our Hunting Services',
      subtitle: 'Exceptional Hunting Experiences',
      items: [
        {
          name: 'Deer Hunting',
          description: 'Track white-tailed deer in our vast territories. Excellent population and impressive trophies.',
          features: ['Experienced guides', 'Exclusive territories', 'Equipment provided', 'Full support']
        },
        {
          name: 'Bear Hunting',
          description: 'Experience the thrill of black bear hunting with our expert guides. All bear hunting stays include fishing rights!',
          features: ['Prepared stands', 'Professional baiting', 'Fishing rights included', '20+ sites active for 10+ years']
        },
        {
          name: 'Turkey Hunting',
          description: 'Wild turkey hunting in spring, a unique experience in the Outaouais forests.',
          features: ['Spring season', 'Calling techniques', 'Specialized guides', 'Small groups']
        }
      ]
    },
    packages: {
      title: 'Our Bear Hunting Packages',
      subtitle: 'All Packages Include Fishing Rights',
      note: 'Prices shown are without guide. Option to have a professional guide accompany you to maximize success.',
      guidePrice: '* Professional guide price: $299.99 / day',
      chaletMin: '* Minimum 2 people for cabin convenience',
      fishingGuide: 'Guided fishing available upon request.',
      items: [
        {
          name: 'Camping Stay',
          duration: '4 Days / 3 Nights',
          price: '1099',
          features: [
            'Camping site',
            '4 days bear hunting',
            'Fishing rights included',
            'Access to 20+ active hunting sites',
            'Professional baiting',
            'Territory transport'
          ],
          popular: false
        },
        {
          name: 'Cabin Accommodation Stay',
          duration: '4 Days / 3 Nights',
          price: '1599.99',
          features: [
            'Comfortable cabin accommodation',
            '4 days bear hunting',
            'Fishing rights included',
            'Access to Lake Saint-Marie & remote lakes',
            'Professional baiting',
            'Game preparation'
          ],
          popular: true
        },
        {
          name: 'VIP Stay - Full Season',
          duration: 'Complete Bear Season',
          price: '2500',
          spotsLeft: 'Only 6 spots available!',
          features: [
            'RV/fifth wheel accommodation with hydro',
            'Full bear season access',
            'Unlimited fishing all season',
            'Lake Saint-Marie access (walleye, pike, trout)',
            'Secret lakes access (brook trout)',
            'Sites renewed every 5 years',
            'Professional baiting'
          ],
          popular: false
        }
      ]
    },
    deerRules: {
      title: 'Deer Hunting Regulations',
      subtitle: 'Important Information',
      rules: [
        {
          title: 'MANDATORY RTLB',
          description: 'A $1000 surcharge must be paid if you harvest a buck that does not meet RTLB (Legal Antler Size Regulation).'
        },
        {
          title: 'Wildlife Protection',
          description: 'No harvest of doe with fawn. You come hunt with us for the chance to harvest a mature buck, not to fill your freezer.'
        },
        {
          title: 'Youth Exception',
          description: 'Exception for youth hunters between 12 and 17 years old. We grant this privilege to only 1 youth per hunting territory per year.'
        }
      ]
    },
    groupSpecials: {
      title: 'Group Specials',
      subtitle: 'Save by Hunting in Groups',
      specials: [
        {
          title: 'Group of 4 Hunters or More',
          description: 'The 5th hunter is half price!'
        },
        {
          title: 'Free Youth Hunt (12-14 years)',
          description: 'Youth aged 12 to 14 get their stay for free. Only 1 child per group can get their hunt for free.'
        }
      ]
    },
    gallery: {
      title: 'Photo Gallery',
      subtitle: 'Discover Our Trophies and Facilities',
      categories: ['All', 'Deer', 'Bear', 'Turkey', 'Facilities', 'Territory']
    },
    turkeyPackage: {
      title: 'Guided Turkey Hunt Package',
      package: {
        name: 'Guided Turkey Hunt Stay',
        duration: '3 Days / 2 Nights',
        price: '1199',
        features: [
          'Comfortable cabin accommodation',
          '3 days guided turkey hunting',
          'Professional experienced guide',
          'Specialized calling techniques',
          'Exclusive territories',
          'Basic equipment provided'
        ]
      }
    },
    deerPackages: {
      title: 'Our Deer Hunting Packages',
      subtitle: 'Hunt Mature Bucks',
      deposit: '30% deposit upon booking',
      note: 'Prices shown are without guide. Option to have a professional guide.',
      guidePrice: '* Professional guide price: $299.99 / day',
      chaletMin: '* Minimum 2 people for cabin convenience',
      items: [
        {
          name: 'Camping Stay',
          duration: '4 Days / 3 Nights',
          price: '1099',
          features: [
            'Camping site',
            '4 days deer hunting',
            'Exclusive private territories',
            'RTLB mandatory',
            'Territory transport',
            'Bait/Stand provided'
          ],
          popular: false
        },
        {
          name: 'Cabin Accommodation Stay',
          duration: '4 Days / 3 Nights',
          price: '1599.99',
          features: [
            'Comfortable cabin accommodation',
            '4 days deer hunting',
            'Exclusive private territories',
            'RTLB mandatory',
            'Game preparation'
          ],
          popular: true
        }
      ]
    },
    premiumPackage: {
      title: 'Exclusive 5-Star Combined Package',
      subtitle: '⭐⭐⭐⭐⭐ Ultra Premium - Complete Guided Hunt',
      package: {
        name: '5-Star Package - Turkey, Bear & Deer',
        description: '4 days of hunting for EACH game with professional guide',
        price: '5000',
        features: [
          '4 days guided turkey hunting',
          '4 days guided bear hunting',
          '4 days guided deer hunting',
          'Professional guide for entire duration',
          'Full accommodation included',
          'All exclusive private territories',
          'Professional baiting',
          'Preparation of all game',
          'Fishing access throughout stay'
        ],
        availability: 'Only 4 five-star packages available per season',
        deposit: '50% deposit upon booking',
        contact: 'Call or text for more info or booking',
        note: 'Few spots still available for 2026 season!'
      }
    },
    fishing: {
      title: 'Fishing Included',
      subtitle: 'Access to Exceptional Waters',
      description: 'All bear hunting stays include fishing rights. Bring your own boats.',
      locations: [
        {
          name: 'Lake Saint-Marie',
          description: 'Immense and majestic lake for walleye, pike and grey trout fishing',
          species: ['Walleye', 'Pike', 'Grey Trout']
        },
        {
          name: 'Secret Remote Lakes',
          description: 'Several small remote and secret lakes for brook trout fishing',
          species: ['Brook Trout']
        }
      ],
      note: 'You must bring your own boats for fishing.'
    },
    testimonials: {
      title: 'Testimonials',
      subtitle: 'What Our Clients Say',
      items: [
        {
          name: 'Jean-Marc Dubois',
          location: 'Montreal, QC',
          rating: 5,
          text: 'An exceptional experience! The guides are professional and the territory is magnificent. I managed to take down an 8-point buck. I will definitely return!',
          hunt: 'Deer Hunt - October 2024'
        },
        {
          name: 'Robert Thompson',
          location: 'Toronto, ON',
          rating: 5,
          text: 'Best hunting experience I\'ve had in Canada. The staff is incredible, accommodations are comfortable, and the success rate speaks for itself. Highly recommended!',
          hunt: 'Bear Hunt - September 2024'
        },
        {
          name: 'Pierre Lavoie',
          location: 'Gatineau, QC',
          rating: 5,
          text: 'Perfect from start to finish. The warm welcome, impeccable facilities and passionate guides make all the difference. My son and I experienced unforgettable moments.',
          hunt: 'Turkey Hunt - May 2024'
        }
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Book Your Next Adventure',
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email Address',
        phone: 'Phone',
        huntType: 'Hunt Type',
        huntTypes: {
          deer: 'Deer',
          bear: 'Bear',
          turkey: 'Turkey',
          multiple: 'Combination'
        },
        dates: 'Preferred Dates',
        guests: 'Number of Hunters',
        message: 'Message / Questions',
        submit: 'Send Request',
        success: 'Thank you! We will contact you within 24h.',
        error: 'Error sending. Please try again.'
      },
      info: {
        title: 'Information',
        address: '7 Chemin du Marais, Danford Lake, QC',
        phone: '(819) 431-2712',
        email: 'hdnighttrain@outlook.com',
        hours: 'Monday - Sunday: 8am - 8pm'
      }
    },
    footer: {
      description: 'Your ultimate destination for big game hunting in Outaouais. Experience, tradition and guaranteed success.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      rights: 'All rights reserved.'
    }
  }
};

// Gallery images (real trophy photos + stock images)
export const galleryImages = [
  { id: 1, url: 'https://customer-assets.emergentagent.com/job_lodge-website/artifacts/9nyrs5q7_20251109_112403.jpg', category: 'deer', alt: 'Magnifique cerf - Trophée client' },
  { id: 2, url: 'https://customer-assets.emergentagent.com/job_lodge-website/artifacts/tgtbnobo_20251109_112421.jpg', category: 'deer', alt: 'Superbe buck - Succès de chasse' },
  { id: 3, url: 'https://customer-assets.emergentagent.com/job_lodge-website/artifacts/6kb8v69t_20251004_193751.jpg', category: 'bear', alt: 'Ours noir - Chasse nocturne' },
  { id: 4, url: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=800', category: 'facilities', alt: 'Chalet moderne au Québec' },
  { id: 5, url: 'https://images.unsplash.com/photo-1484406566174-9da000fda645?w=800', category: 'deer', alt: 'Buck mature avec bois impressionnants' },
  { id: 6, url: 'https://images.unsplash.com/photo-1588204812874-5a94f1d63439?w=800', category: 'bear', alt: 'Ours noir mature du Québec' },
  { id: 7, url: 'https://images.unsplash.com/photo-1616889638982-b06121164c3d?w=800', category: 'turkey', alt: 'Dindon sauvage' },
  { id: 8, url: 'https://images.unsplash.com/photo-1762626472803-74acd75c1e8b?w=800', category: 'territory', alt: 'Forêt d\'érables en automne' }
];
